import { render, staticRenderFns } from "./Facility.vue?vue&type=template&id=878c4f66"
import script from "./Facility.vue?vue&type=script&lang=js"
export * from "./Facility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports